import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import './LoginPage.css'

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/v1'

const pcdueLogoCandidates = [
  '/pcdue%20logo.png',
  '/pcdue-logo.png',
  '/pcdue_logo.png',
]

const LoginPage = () => {
  const [searchParams] = useSearchParams()
  const [error, setError] = useState('')
  const [pcdueLogoIndex, setPcdueLogoIndex] = useState(0)

  useEffect(() => {
    const oauthError = searchParams.get('error')
    if (oauthError) {
      let displayError = decodeURIComponent(oauthError)
      if (displayError === 'Access restricted to @sfre.it accounts.') {
        displayError =
          "L'accesso è limitato agli account aziendali (@sfre.it). Utilizza il tuo account Google SFRE."
      } else if (displayError.includes('Authentication failed')) {
        displayError =
          'Autenticazione fallita. Riprova. Se il problema persiste, contatta il supporto.'
      } else if (
        displayError === 'An_unexpected_authentication_error_occurred._Missing_token.'
      ) {
        displayError =
          'Si è verificato un errore di autenticazione imprevisto. Token mancante.'
      } else if (displayError === 'maintenance_restricted') {
        displayError =
          'Accesso limitato durante la manutenzione. Solo gli utenti autorizzati possono continuare. / Access is limited during maintenance. Only authorized users can continue.'
      }
      setError(displayError)
    }
  }, [searchParams])

  const handleLogin = () => {
    const googleLoginUrl = `${API_BASE_URL}/auth/login/google`
    window.location.href = googleLoginUrl
  }

  const handlePcdueLogoError = () => {
    if (pcdueLogoIndex < pcdueLogoCandidates.length - 1) {
      setPcdueLogoIndex(prev => prev + 1)
    }
  }

  return (
    <div className="login-container">
      <div className="login-backdrop-wave login-wave-top" />
      <div className="login-backdrop-wave login-wave-bottom" />

      <div className="login-box">
        <div className="maintenance-banner">
          <strong>Manutenzione in corso / Maintenance in progress:</strong> gli
          utenti autorizzati possono continuare il login.
        </div>

        <img
          src="/franca-logo.png"
          alt="SFRE F.R.A.N.C.A. AI Logo"
          className="login-logo"
        />
        <h1>Benvenuto / Welcome back</h1>
        <p className="sfre-tagline">
          FRANCA sta ricevendo un aggiornamento premium da SFRE x PCDUE.
        </p>

        <div className="brand-lockup">
          <span>Realizzato da / Powered by</span>
          <img src="/franca-logo.png" alt="SFRE logo" className="brand-mini" />
          <img
            src={pcdueLogoCandidates[pcdueLogoIndex]}
            alt="PCDUE logo"
            className="brand-mini pcdue"
            onError={handlePcdueLogoError}
          />
        </div>

        {error && <p className="login-error">{error}</p>}

        <button onClick={handleLogin} className="google-auth-button">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid"
            viewBox="0 0 256 262"
            className="google-auth-svg"
          >
            <path
              fill="#4285F4"
              d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
              className="google-auth-svg-blue"
            />
            <path
              fill="#34A853"
              d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
              className="google-auth-svg-green"
            />
            <path
              fill="#FBBC05"
              d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"
              className="google-auth-svg-yellow"
            />
            <path
              fill="#EB4335"
              d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
              className="google-auth-svg-red"
            />
          </svg>
          <span className="google-auth-text">
            Continua con Google / Continue with Google
          </span>
        </button>
      </div>
      <footer className="login-footer">
        Creato con cura da SFRE Innovation per PCDUE
      </footer>
    </div>
  )
}

export default LoginPage